import { QesIcon } from "@app/shared/icons/QESIcon";
import { QesIcons } from "@app/shared/icons/qesIcons";
import TooltipWrapper from "@app/shared/TooltipWrapper";
import { FC, ComponentProps } from "react";

export const AIChatPanelProviderLink: FC<ComponentProps<'a'>> = (props) => {
  return (
    <TooltipWrapper text="View in new tab" position="left" tooltipBodyClassName="ai-chat-panel__provider-link-tooltip">
      <a {...props} target="_blank" rel="noreferrer"
         data-testid={`ai-chat-panel__provider-link--${props.href}`}
         className="ai-chat-panel__provider-link">
        {props.children}<QesIcon iconName={QesIcons.ShareV4} description="open link in new tab" />
      </a>
    </TooltipWrapper>
  )
}